import { createFileRoute } from '@tanstack/react-router';

import { AccessibilityPageView } from '@/components/site/pages';
import { seoHead } from '@/lib/seo';

export const Route = createFileRoute('/accessibility')({
    head: () =>
        seoHead({
            title: 'הצהרת נגישות',
            description:
                'הצהרת נגישות של אשקלון ניוז - מידע בסיסי על נגישות האתר ודרכי פנייה.',
            path: '/accessibility',
        }),
    component: AccessibilityPage,
});

function AccessibilityPage() {
    return <AccessibilityPageView />;
}
